<script>
import UsesCookies from '@/mixins/UsesCookies'
const GOOGLE_SDK_URL = 'https://apis.google.com/js/api.js'
const OAUTH_TOKEN_FETCH_URL = '/app/file/googleOauthTokenFetch'
let google

export default {
  name: 'GooglePickerMixin',
  mixins: [UsesCookies],
  data () {
    return {
      boundMessageHandler: this.messageHandler.bind(this),
      google,
      iframeQueryOptions: {
        fontSize: '16px',
        hoverColor: 'white',
        iconSize: 16,
        linkColor: '#646464'
      },
      iframeSrc: '',
      oauthToken: '',
      pickerApiLoaded: false
    }
  },
  async mounted () {
    const googlePickerOauthToken = localStorage.getItem('googlePickerOauthToken')
    if (googlePickerOauthToken) {
      try {
        const { value, expires } = JSON.parse(googlePickerOauthToken)
        const now = new Date().getTime() / 1000
        if (now > expires) {
          localStorage.removeItem('googlePickerOauthToken')
        } else {
          this.oauthToken = value
          setTimeout(() => {
            this.oauthToken = ''
            localStorage.removeItem('googlePickerOauthToken')
          }, (expires - now) * 1000)
        }
      } catch (e) {
        // ignore
      }
    }
    if (this.isGoogleReady()) {
      await this.$nextTick()
      this.gDriveLoaded()
    } else {
      const gDrive = document.createElement('script')
      gDrive.setAttribute('type', 'text/javascript')
      gDrive.setAttribute('src', GOOGLE_SDK_URL)
      gDrive.addEventListener('load', this.gDriveLoaded.bind(this))
      document.head.appendChild(gDrive)
    }
  },
  methods: {
    async driveIconClicked () {
      if (!this.oauthToken) {
        return
      }
      this.defaultCreatePicker()
    },
    defaultCreatePicker () {
      if (this.pickerApiLoaded && this.oauthToken) {
        const docsView = new google.picker.DocsView()
          .setIncludeFolders(true)
          .setSelectFolderEnabled(true)
          .setOwnedByMe(true)
          .setMode(google.picker.DocsViewMode.LIST)
        const sharedView = new google.picker.DocsView()
          .setIncludeFolders(true)
          .setSelectFolderEnabled(true)
          .setOwnedByMe(false)
          .setMode(google.picker.DocsViewMode.LIST)
        const teamView = new google.picker.DocsView()
          .setIncludeFolders(true)
          .setSelectFolderEnabled(true)
          .setEnableTeamDrives(true)
          .setMode(google.picker.DocsViewMode.LIST)
        const picker = new google.picker.PickerBuilder()
          .enableFeature(google.picker.Feature.MULTISELECT_ENABLED)
          .addView(docsView)
          .addView(sharedView)
          .addView(teamView)
          .setOAuthToken(this.oauthToken)
          .setCallback(this.pickerCallback)
          .build()
        picker.setVisible(true)
      }
    },
    gapiPickerLoaded () {
      google = window.google
      this.pickerApiLoaded = true
      this.iframeSrc = this.getIframePath() + OAUTH_TOKEN_FETCH_URL + '?' + this.getIframeQuery()
      window.addEventListener('message', this.boundMessageHandler)
    },
    // Google Drive Picker methods
    gDriveLoaded () {
      window.gapi.load('auth')
      window.gapi.load('picker', this.gapiPickerLoaded)
    },
    getIframeQuery () {
      const params = new URLSearchParams(this.iframeQueryOptions)
      const lang = this.getLangFromCookies()
      params.append('dir', ['ar', 'iw'].includes(lang) ? 'rtl' : 'ltr')
      params.append('lang', lang)
      params.append('delegateId', this._uid)
      params.append('origin', window.location.origin)
      return params.toString()
    },
    isGoogleReady () {
      return !!window.gapi
    },
    isGoogleAuthReady () {
      return !!window.gapi.auth
    },
    getIframePath () {
      return process.env.VUE_APP_IFRAME_DOMAIN
    },
    messageHandler (event) {
      if (!event.origin || (window.location.href.includes('.rubicon') && !event.origin.includes('.rubicon'))) {
        return
      }
      if (typeof event === 'object' && event?.data?.access_token && event?.data?.expires_in) {
        const value = event.data.access_token
        const expireDate = new Date()
        expireDate.setSeconds(expireDate.getSeconds() + event.data.expires_in)
        localStorage.setItem('googlePickerOauthToken', JSON.stringify({ value, expires: expireDate.getTime() / 1000 }))
        this.oauthToken = event.data.access_token
        setTimeout(function() {
          localStorage.removeItem('googlePickerOauthToken')
          this.oauthToken = ''
        }, event.data.expires_in * 1000)
        if (+event.data.delegateId === this._uid) {
          this.defaultCreatePicker()
        }
        window.removeEventListener('message', this.boundMessageHandler)
      }
    },
    pickedDocMapper (doc) {
      return {
        AttachmentLink: doc.url,
        AttachmentName: doc.name,
        AttachmentType: 'googleDrive',
        IconURL: doc.iconUrl
      }
    },
    async pickerCallback (data) {
      if (data[google.picker.Response.ACTION] === google.picker.Action.PICKED) {
        this.$emit('save-external-links', { links: data.docs.map(this.pickedDocMapper) })
      }
    }
  }
}

</script>
